import React, { useMemo } from 'react'
import { GridRowModel } from '@mui/x-data-grid-pro'
import { getFormattedAddress } from '@sales-center/common'
import AddressMapLink from '@user/features/MapView/AddressMapLink/AddressMapLink'

type ListViewAddressMapLinkProps = {
  row: GridRowModel
}

function ListViewAddressMapLink({ row }: ListViewAddressMapLinkProps) {
  const formattedAddress = useMemo(
    () =>
      getFormattedAddress(
        row.serviceLocation.lineOne,
        row.serviceLocation.lineTwo,
        row.serviceLocation.city,
        row.serviceLocation.state,
        row.serviceLocation.postalCode,
      ),
    [row.serviceLocation],
  )

  return row.serviceLocation ? (
    <AddressMapLink
      address={formattedAddress}
      entityId={row.id}
      entityType={row.entityType}
      serviceLocationId={row.serviceLocation.locationId}
      latitude={row.serviceLocation.latitude}
      longitude={row.serviceLocation.longitude}
      noWrap
    >
      {formattedAddress}
    </AddressMapLink>
  ) : (
    formattedAddress
  )
}

export default ListViewAddressMapLink
